var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.82172C0 1.33857 0.193154 0.875207 0.536971 0.533569C0.880788 0.191931 1.3471 0 1.83333 0H20.1667C20.6529 0 21.1192 0.191931 21.463 0.533569C21.8068 0.875207 22 1.33857 22 1.82172V4.35512C21.9999 4.99927 21.7422 5.61698 21.2838 6.07239L14.6667 12.6476V21.6639C14.6667 21.8916 14.6081 22.1156 14.4966 22.3145C14.385 22.5134 14.224 22.6807 14.0291 22.8004C13.8341 22.9202 13.6116 22.9884 13.3826 22.9986C13.1537 23.0089 12.9259 22.9608 12.7209 22.8589L8.17789 20.6024C7.92412 20.4763 7.71069 20.2825 7.56153 20.0427C7.41236 19.8029 7.33334 19.5266 7.33333 19.2446V12.6476L0.716222 6.07239C0.257768 5.61698 0.000138447 4.99927 0 4.35512V1.82172ZM2.44444 2.42896V4.35512L9.24 11.1076C9.41044 11.2768 9.54566 11.4776 9.63793 11.6987C9.7302 11.9198 9.77773 12.1568 9.77778 12.3962V18.6811L12.2222 19.8956V12.3962C12.2222 11.9128 12.4153 11.4489 12.76 11.1088L19.5556 4.35391V2.42896H2.44444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterWhite);
export default __webpack_public_path__ + "static/media/FilterWhite.68b53e83e72f01007f3215152f6df3f6.svg";
export { ForwardRef as ReactComponent };